import React from 'react';
import { CardConfig } from 'components/description-card/DescriptionCard';
import { ReactComponent as Congrat } from 'assets/icons/school-congrat.svg';
import { ReactComponent as Lock } from 'assets/icons/school-lock.svg';
import { ReactComponent as Puzzle } from 'assets/icons/school-puzzle.svg';
import { ReactComponent as People } from 'assets/icons/schools-people.svg';

export const SCHOOLS_DESCRIPTION_CARDS: CardConfig[] = [
    {
        title: 'school-description-card-1',
        icon: <Lock />,
    },
    {
        title: 'school-description-card-2',
        icon: <Congrat />,
    },
    {
        title: 'school-description-card-3',
        icon: <People />,
    },
    {
        title: 'school-description-card-4',
        icon: <Puzzle />,
    },
];
